import AirportList from './AirportList';

export default AirportList;
